import { render, staticRenderFns } from "./admin.status.vue?vue&type=template&id=25b69e7f&scoped=true&"
import script from "./admin.status.vue?vue&type=script&lang=js&"
export * from "./admin.status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b69e7f",
  null
  
)

export default component.exports